import { bisectLeft } from '../bisect-left/bisectLeft';

export const bisectCenter = (data: Record<string, unknown>[], key: string, target: number) => {
  const low = bisectLeft(data, key, target);
  if (low > 0 && (low === data.length || target - (data[low - 1][key] as number) <= (data[low][key] as number) - target)) return low - 1;
  return low;
};
